























import { Component, Vue, Prop } from "vue-property-decorator";
import { Message } from "element-ui";
import { mapGetters } from "vuex";
import version from "@/version";
@Component({
  ...mapGetters(["account"])
})
export default class AccounterImport extends Vue {
  @Prop({ type: String })
  period!: string;
  file: any = null;
  fileName: string = "";
  changeFile(e: any) {
    if (e.target.files[0]) {
      this.file = e.target.files[0];
    }
  }
  getFileName(el: any) {
    let filename = el.currentTarget.files[0].name;
    let postfixname = filename.substring(filename.length - 3, filename.length);
    let fileName: any = document.querySelector("#fileInput .fileName");
    fileName.innerHTML = filename;
    this.fileName = filename;
  }
  fnUpload() {
    let bookName, bookCode, data, num;
    let upfile: any = document.querySelector("#upfile");
    data = new FormData();
    data.append("file", upfile.files[0]);
    data.append("fileName", this.fileName);
    data.append("token", this.$store.state.account.token);
    data.append("version", version);
    this.submit(data);
  }
  url: string = `system/set/accountbookinfo`;
  submit(data: any) {
    Vue.axios.post(`accounts/upload`, data).then(res => {
      console.log(res.data);
      if (res.data.code === 200) {
        this.$message.warning(res.data.data);
      } else this.$message.warning(res.data.data);
      let fileName: any = document.querySelector("#fileInput .fileName");
      fileName.innerHTML = "";
      this.file = null;
      this.fileName = "";
    });
  }
}
